import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useInboxDock } from './InboxDock';

/**
 * `/inbox` is no longer a page — the inbox lives above every page instead. Old
 * bookmarks and links land here, so honour the intent: open the inbox, then get
 * out of the way rather than showing a second copy of the same list.
 */
export default function InboxPage() {
  const dock = useInboxDock();

  useEffect(() => {
    dock?.setOpen(true);
  }, [dock]);

  return <Navigate to="/funerals" replace />;
}
